module.exports = __webpack_public_path__ + "img/collection-engagementRingsExclusive@2x.73a9fd9.webp";